import { useMutation } from '@tanstack/react-query';
import { login } from '@/api/auth';
import { applyAuthResult } from './auth-session';

/**
 * `POST /api/auth/login` como mutación (TanStack Query).
 *
 * Al responder bien aplica la sesión (`applyAuthResult`): guarda token/usuario/tenants en el
 * store y siembra la caché de `/api/auth/me`, de forma que `RequireAuth` deja entrar al
 * panel sin volver a mostrar la pantalla de carga.
 *
 * La navegación la decide la pantalla (necesita el `from` de `location.state`), y los errores
 * se muestran con `getErrorMessage` / `formErrorsFromApiError`. Las mutaciones no se
 * reintentan solas (config del `queryClient`), así que un fallo de credenciales se ve al
 * instante.
 */
export function useLogin() {
  return useMutation({
    mutationFn: login,
    onSuccess: applyAuthResult,
  });
}
